export default __webpack_public_path__ + "static/media/bg-small.9a3275a8.png";